module.exports = __webpack_public_path__ + "static/media/albalat_logo.5c148adc.png";